import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const chartDetailsRootSx: SxProps<Theme> = {
  backgroundColor: Color.solidGray,
  padding: '0 22px 120px 22px',
  display: 'flex',
  flexFlow: 'column nowrap',
  minHeight: '100%',
};
